import FundInvestmentInvestor from '../../../models/admin/FundInvestmentData';
import { currentInvestment, investorToContactCardProps } from '../../../models/Investor';
import type { InvestorListRowContact } from './InvestorListRow';

export interface InvestorContactCardActions {
  onPromote: (investor: FundInvestmentInvestor) => void;
  onDemote: (investor: FundInvestmentInvestor) => void;
  onDelete?: (investor: FundInvestmentInvestor) => void;
}

export function buildInvestorContactCards(
  investors: FundInvestmentInvestor[] | undefined,
  stage: FundInvestmentInvestor['status'],
  investorFilter: string,
  options: {
    withInvestment?: boolean;
    withoutInvestment?: boolean;
  },
  actions: InvestorContactCardActions,
): InvestorListRowContact[] {
  if (!investors) {
    return [];
  }

  let filteredInvestors = investors.filter((investor) => {
    if (investor.status !== stage) {
      return false;
    }

    const { withInvestment, withoutInvestment } = options;
    const investment = currentInvestment(investor);
    if (withInvestment && !investment) {
      return false;
    }
    if (withoutInvestment && investment) {
      return false;
    }
    return true;
  });

  if (investorFilter) {
    const filterLower = investorFilter.toLowerCase();
    filteredInvestors = filteredInvestors.filter((investor) => {
      return (
        (investor.name && investor.name.toLowerCase().includes(filterLower)) ||
        (investor.email && investor.email.toLowerCase().includes(filterLower))
      );
    });
  }

  return filteredInvestors.map((investor) => ({
    ...investorToContactCardProps(
      investor,
      'tone1',
      () => actions.onPromote(investor),
      () => actions.onDemote(investor),
      investor.status === 'CANDIDATE' ? () => actions.onDelete?.(investor) : undefined,
    ),
    viewLinks: {
      investor: `/opportunities/${investor.fundOpportunityId}/investors/${investor.id}`,
      contact: `/contacts/${investor.contactId}`,
    },
  }));
}
